
import React, { useState } from 'react';
import { Dropdown } from 'semantic-ui-react';

export const CustomDropdown = ({ options, value, onChange }) => {
  const [open, setOpen] = useState(false);

  const handleOptionClick = (e, option) => {
    e.stopPropagation();
    const newValue = [...value];
    const index = newValue.indexOf(option.value);

    if (index > -1) {
      newValue.splice(index, 1);
    } else {
      newValue.push(option.value);
    }

    onChange(e, { value: newValue });
  };

  return (
    <Dropdown
      fluid
      selection
      open={open}
      onOpen={() => setOpen(true)}
      onClose={() => setOpen(false)}
      className="tw-h-[38.5px] companyListDropdownItems notranslate tw-text-center"
      style={{ width: "320px" }}
      noResultsMessage="La empresa no existe."
      selectOnBlur={false}
      openOnFocus={false}
      trigger={
        <div>
          {value.length > 0
            ? `${value.length} empresas seleccionadas`
            : 'Seleccione empresas'}
        </div>
      }
    >
      <Dropdown.Menu>
        {options.map(option => (
          <Dropdown.Item key={option.value} onClick={(e) => e.preventDefault()}>
            <div
              className="tw-flex tw-items-center"
              onClick={(e) => handleOptionClick(e, option)}
            >
              <input
                type="checkbox"
                checked={value.includes(option.value)}
                onChange={() => { }}
                className="tw-mr-2"
              />
              {option.text}
            </div>
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
}